import { __ } from '@wordpress/i18n';
import React, { useMemo } from 'react';
import { useStoreValue } from '../../../../store';
import { normalizeProjectStatus } from '../../../../components/ProjectStatusIcon';

const WidgetProjects = () => {
    const projects = useStoreValue('projects');
    const counts = useMemo(() => {
        const active = projects.filter(o => !o.archived);
        const completed = active.filter(o => 'completed' === normalizeProjectStatus(o.status));

        return { ongoing: active.length - completed.length, completed: completed.length };
    }, [projects]);

    return(
        <div className="appDashboard__widget">
            <div className="appDashboard__widgetTitle">
                <h2>{__('Progetti', 'soundbetween')}</h2>
            </div>
            <ul>
                <li><span>{counts.ongoing}</span> {__('Progetti in Corso', 'soundbetween')}</li>
                <li><span>{counts.completed}</span> {__('Progetti Conclusi', 'soundbetween')}</li>
            </ul>
        </div>
    )
}

export default WidgetProjects;